import { defineMessages } from 'react-intl';

export default defineMessages({
  quickAdd: {
    id: 'app.components.TagsAutocomplete.quickAdd',
    defaultMessage: 'Quick add:',
  },
});
